import { useAppDispatch } from 'app/hooks'
import { getWidgetForDashboard } from 'features/widget/asyncThunks'
import { useDashboardData, useDashboardWidgetSetting } from 'hooks/useDashboardState'
import { useEffect } from 'react'
import { Dashboard } from 'schemas/DashboardSchema'
import { createInsightCount } from 'utils/runSearchUtil'
import { toFilter } from 'utils/widgetUtil'
import { WidgetId } from 'features/types'
import Measure from 'enums/Measure'
import { getEmojiCategory, getInsightCategory } from 'utils/viewOptionUtil'
import useRefreshTimestamp from 'hooks/useRefreshTimestamp'

import { TrendingWidgetsType } from '../../types'

const createSearch = (widgetSetting: TrendingWidgetsType, dashboardData: Dashboard) => {
  const { selectedTopic, viewOption, precision, analysisType } = widgetSetting
  const filter = toFilter(widgetSetting)
  const topicIds = [selectedTopic.topicId!]
  const EXACT_COUNT = 50
  const { id: dashboardId, name } = dashboardData
  const categories = getInsightCategory(viewOption!, analysisType)

  const measure = Measure.POSTS
  const insightCountOptions = {
    exactCount: EXACT_COUNT,
    emojiCategory: getEmojiCategory(viewOption)
  }

  return createInsightCount(
    dashboardId!,
    name!,
    precision!,
    topicIds,
    filter,
    measure!,
    categories,
    insightCountOptions
  )
}

const RunSearchEffect = ({
  widgetId,
  children
}: {
  widgetId: WidgetId
  children: React.ReactElement
}) => {
  const widgetSetting = useDashboardWidgetSetting<TrendingWidgetsType>(widgetId)
  const dashboardData = useDashboardData()
  const dispatch = useAppDispatch()
  const refreshTimestamp = useRefreshTimestamp(widgetId)

  useEffect(() => {
    const search = createSearch(widgetSetting, dashboardData!)

    dispatch(
      getWidgetForDashboard({
        searches: [search],
        widgetId: widgetSetting.widgetId!,
        timestamp: refreshTimestamp
      })
    )
  }, [widgetSetting, dashboardData, dispatch, refreshTimestamp])

  return children
}

export default RunSearchEffect
